module.exports = __webpack_public_path__ + "static/business-port-03b5077faded3f43c00dda4bd864f3fc.png";